import { createGraph } from '../graph/graphModel.js';
import { serializeGraph } from '../graph/graphSerialization.js';
import { getHassNodeSchema, getHassPalette } from '../Hasp/properties/v2/hass/index.js';
import GraphCommand from '../history/commands/GraphCommand.js';
import { canConnect, connect, extractObjectsHass, validateHassGraph } from './hassGraph.js';
import { createHassNode, HASS_ID_PREFIX } from './hassNodeFactory.js';
import { planHassPaletteNode } from './hassPlacement.js';
import { createPageHassContext, deserializeHassGraph } from './pageHass.js';

/**
 * The Home Assistant flow graph as a canvas graph domain: what the generic
 * graph store (stores/graphStoreOptions.js) and the graph clipboard
 * (graph/graphClipboard.js) need to edit `page.hass`.
 */
export const hassDomain = Object.freeze({
    graphKey: 'hass',
    mode: 'hass',
    noun: 'HA flow',
    createGraph,
    createNode: createHassNode,
    getNodeSchema: getHassNodeSchema,
    getPalette: getHassPalette,
    planPaletteNode: planHassPaletteNode,
    connect,
    canConnect,
    validate: validateHassGraph,
    createContext: createPageHassContext,
    createCommand: options => new GraphCommand({ ...options, graphKey: 'hass', type: 'HassFlow', category: 'homeassistant' }),
    // Clipboard and custom components.
    extract: extractObjectsHass,
    idPrefix: HASS_ID_PREFIX,
    serialize: serializeGraph,
    deserialize: deserializeHassGraph,
});
